import React from 'react';
import moment from 'moment';
import Listview from "../../../../core/form/components/Listview";
import { jira_issue_link } from '../../../../../constants/jira.js';

const ProjectsCommentsLsv = (props) => {
  const {
    rows,
    hideHeader,
    darkTable,
    titleKey
  } = props;

  const renderRows = (headers, task) => {
    let link = '#';
    if (jira_issue_link) link = `${jira_issue_link}/${task.key}`;

    const updated = moment(task.updated).fromNow();

    const tableTd = headers.map((header, index) => {
      switch (header.field) {
        case 'updated': return  (
          <td key={index} className={header.classes} style={{width: 100}}>{updated}</td>
        )
        case 'key': return  (
          <td key={index} className={header.classes} >
            <a rel="noopener noreferrer" target="_blank" href={link} >{task[header.field]}</a>
          </td>
        )
        default: return  (
          <td key={index} className={header.classes}>{task[header.field]}</td>
        )
      }
    });

    return tableTd;
  }

  const headers = [
    {caption: 'Updated', field: 'updated', classes:'text-left'},
    {caption: 'Comment', field: 'comment', classes:'text-left'},
    {caption: 'Author', field: 'author', classes:'text-left'},
    {caption: 'Jira Key', field: 'key', classes:'text-end'},
  ]

  const tableHeadTh = headers.map((header, index) =>
    <th key={index} className={header.classes}>{header.caption}</th>
  );

  let tableBodyTr = (<tr></tr>);
  const haveRows = (rows && rows.length > 0);
  if (haveRows) {
    tableBodyTr = rows.map((row, index) =>
      <tr key={index} onClick={() => {}} style={{cursor: "pointer"}}>
        {renderRows(headers, row)}
      </tr>
    );
  }

  const iconName='comments';
  const emptyCaption='No Comments found';
  const title = `${titleKey} - PROJECT COMMENTS`;

  return (
    <div className="bg-white">
      <div className="bg-corporate text-white p-1 pl-2">
        <small>{title}</small>
      </div>
      <Listview darkTable={darkTable} hideHeader={hideHeader} rows={rows} tableHeadTh={tableHeadTh} tableBodyTr={tableBodyTr} iconName={iconName} emptyCaption={emptyCaption}/>
    </div>
  );
}

export default ProjectsCommentsLsv;
